export default __webpack_public_path__ + "static/media/09.346e628c.webp";